import React from "react";
import { Body } from "../../atoms";
import { Section } from "../../molecules";
export var TextIntermission = function(param) {
    var children = param.children, className = param.className, enableLines = param.enableLines;
    return /*#__PURE__*/ React.createElement(Section, {
        container: true,
        lines: enableLines ? "dark" : false,
        backgroundColor: "offdefault",
        className: className
    }, /*#__PURE__*/ React.createElement("div", {
        className: "prose prose-p:text-inherit"
    }, /*#__PURE__*/ React.createElement(Body, {
        variant: "big",
        className: "leading-relaxed md:pr-10 lg:pr-12"
    }, children)));
};

//# sourceMappingURL=TextIntermission.js.map